import {Component, forwardRef, Input, Optional} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';
import { Image as GalleryImage } from 'angular-modal-gallery';
import {NbinputConfig} from "./nbinput.entity";

@Component({
  selector: 'nbinput-gallery',
  template: require('./nbinput-gallery.component.html'),
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => NbinputGalleryComponent),
      multi: true
    }
  ]
})

export class NbinputGalleryComponent implements ControlValueAccessor {
  registerOnChange(fn: any): void {/* gallery不支持用户手动修改值 */}
  registerOnTouched(fn: any): void {}
  setDisabledState?(isDisabled: boolean): void {/* gallery没有禁用与否的区别 */}
  writeValue(obj: string): void {
    setTimeout(()=> {
      this.data = obj;
    }, 0);
  }

  @Input()
  token;
  host = '';
  _data;
  @Input()
  set data(val:any){
    this.imgs = [];
    this._data = val;
    if (!!val){
      if (Array.isArray(val)){
        this.imgs = val.filter((e,i,c)=>{
          let a = !!e&&(((typeof e == 'string')&&e.length>0));
          let b = !!e&&(e.url&&e.url.length>0);
          console.log('c',c,'i',i,'a',a,'b',b,'res',a||b);
          return !!e&&(((typeof e == 'string')&&e.length>0)||e.url&&e.url.length>0)
        }).map(e => (typeof e =='string')
          ?new GalleryImage(
            (e.startsWith("http:")||e.startsWith("https:")?'':this.host)+e+(e.startsWith("http:")||e.startsWith("https:")?'':"?token="+this.token),
            null,
            e.lastIndexOf('.')<0?e:e.substr(e.lastIndexOf('.')),
            (e.startsWith("http:")||e.startsWith("https:")?'':this.host)+e+(e.startsWith("http:")||e.startsWith("https:")?'':"?token="+this.token))
          :new GalleryImage(
            (e.url.startsWith("http:")||e.url.startsWith("https:")?'':this.host)+e.url+(e.url.startsWith("http:")||e.url.startsWith("https:")?'':"?token="+this.token),
            null,
            e.name,
            (e.url.startsWith("http:")||e.url.startsWith("https:")?'':this.host)+e.url+(e.url.startsWith("http:")||e.url.startsWith("https:")?'':"?token="+this.token)));
      } else if (typeof val == 'string'&&val.length>0) {
        this.imgs = [
          new GalleryImage(
            (val.startsWith("http:")||val.startsWith("https:")?'':this.host)+val+(val.startsWith("http:")||val.startsWith("https:")?'':"?token="+this.token),
            null,
            val.lastIndexOf('.')<0?val:val.substr(val.lastIndexOf('.')),
            (val.startsWith("http:")||val.startsWith("https:")?'':this.host)+val+(val.startsWith("http:")||val.startsWith("https:")?'':"?token="+this.token))
        ];
      } else if (val.url&&val.url.length>0) {
        this.imgs = [
          new GalleryImage(
            (val.url.startsWith("http:")||val.url.startsWith("https:")?'':this.host)+val.url+(val.url.startsWith("http:")||val.url.startsWith("https:")?'':"?token="+this.token),
            null,
            val.name,
            (val.url.startsWith("http:")||val.url.startsWith("https:")?'':this.host)+val.url+(val.url.startsWith("http:")||val.url.startsWith("https:")?'':"?token="+this.token))]
      }
    }
  }
  get data(){
    return this._data;
  }
  imgs;
  constructor(
    @Optional() private config: NbinputConfig,
  ) {
    this.host = config.downloadAPI;
  }
}




// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/nbinput/nbinput-gallery.component.ts